<template>
  <div class="desktop-blocked-container">
    <!-- هاله‌های نورانی پس‌زمینه -->
    <div class="glow-orb orb-red"></div>
    <div class="glow-orb orb-gold"></div>

    <!-- کارت شیشه‌ای مرکزی -->
    <div class="glass-card elevation-12">
      <div class="corner-decor-tr"></div>
      <div class="corner-decor-bl"></div>
      <div class="dot-pattern top-left"></div>
      <div class="dot-pattern bottom-right"></div>

      <!-- لوگو مجموعه / کیوآرلند -->
      <div class="logo-container">
        <img
          :src="resolvedLogo"
          alt="لوگو"
          class="blocked-logo"
          @error="fallbackLogo"
        />
      </div>

      <!-- نشان وضعیت امنیتی -->
      <div class="d-flex justify-center">
        <div class="badge-error">
          <span class="badge-dot"></span>
          <span>محیط ورود غیرمجاز (Desktop Detected)</span>
        </div>
      </div>

      <!-- باکس اسکنر لیزری خطا -->
      <div class="security-visual-box">
        <div class="laser-line"></div>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <rect x="2" y="3" width="20" height="14" rx="2"></rect>
          <line x1="8" y1="21" x2="16" y2="21"></line>
          <line x1="12" y1="17" x2="12" y2="21"></line>
          <line x1="2" y1="2" x2="22" y2="22" stroke="#ff2b3e" stroke-width="2.3"></line>
        </svg>
      </div>

      <h2 class="blocked-title">ورود از رایانه و دسکتاپ مجاز نیست</h2>

      <p class="blocked-desc">
        به منظور رعایت امنیت سازمانی، ممانعت از جعل موقعیت مکانی (Fake GPS) و جلوگیری از هرگونه تقلب در تردد، این سامانه
        <strong>تنها بر روی گوشی هوشمند یا تبلت شخصی پرسنل</strong> فعال می‌باشد.
      </p>

      <!-- کادر راهنما -->
      <div class="security-note">
        <v-icon small color="#f7d277" class="ml-2 flex-shrink-0">mdi-cellphone-check</v-icon>
        <span>لطفاً با دوربین گوشی تلفن همراه خود، کیوآر کد حضور و غیاب را اسکن فرمایید.</span>
      </div>

      <!-- دکمه‌ها -->
      <div class="blocked-actions">
        <a href="https://qrland.ir" class="btn-custom btn-gold">
          <v-icon small color="#1b1204" class="ml-1">mdi-home-outline</v-icon>
          صفحه اصلی کیوآرلند
        </a>
      </div>

      <div class="copyright">
        <span>سامانه حضور و غیاب کیوآرلند</span>
        <span>•</span>
        <span>TerminalAds &copy; {{ currentYear }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DesktopBlockedView",
  props: {
    logoUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
      imgFallback: false
    };
  },
  computed: {
    resolvedLogo() {
      if (this.imgFallback || !this.logoUrl) {
        return "/media/cr_logo.webp";
      }
      return this.logoUrl;
    }
  },
  methods: {
    fallbackLogo(e) {
      this.imgFallback = true;
      e.target.src = "/img/webIcon.webp";
    }
  }
};
</script>

<style scoped>
.desktop-blocked-container {
  min-height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at 50% 50%, #171120 0%, #09070c 100%);
  overflow: hidden;
  position: relative;
  direction: rtl;
  padding: 1.5rem 1rem;
  box-sizing: border-box;
  font-family: inherit;
  z-index: 999;
}

/* هاله‌های نوری */
.glow-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  z-index: 1;
  opacity: 0.55;
  pointer-events: none;
  animation: floatLight 10s ease-in-out infinite alternate;
}

.orb-red {
  width: 420px;
  height: 420px;
  background: radial-gradient(circle, #ff2b3e 0%, transparent 70%);
  top: -10%;
  right: -5%;
}

.orb-gold {
  width: 480px;
  height: 480px;
  background: radial-gradient(circle, #f5c044 0%, transparent 70%);
  bottom: -15%;
  left: -5%;
  animation-delay: -5s;
}

@keyframes floatLight {
  0% { transform: translate(0, 0) scale(1); }
  100% { transform: translate(30px, -25px) scale(1.15); }
}

/* کارت شیشه‌ای */
.glass-card {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 470px;
  padding: 2.2rem 1.8rem 1.8rem;
  border-radius: 32px;
  background: rgba(18, 14, 24, 0.78);
  backdrop-filter: blur(28px) saturate(190%);
  -webkit-backdrop-filter: blur(28px) saturate(190%);
  border: 1px solid rgba(245, 192, 68, 0.22);
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.8),
              inset 0 1px 2px rgba(255, 255, 255, 0.25),
              inset 0 -1px 2px rgba(245, 192, 68, 0.2);
  text-align: center;
  overflow: hidden;
}

.corner-decor-tr {
  position: absolute;
  top: 0;
  right: 0;
  width: 90px;
  height: 90px;
  background: radial-gradient(circle at 100% 0%, rgba(255, 43, 62, 0.35) 0%, transparent 70%);
  pointer-events: none;
}

.corner-decor-bl {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 90px;
  height: 90px;
  background: radial-gradient(circle at 0% 100%, rgba(245, 192, 68, 0.25) 0%, transparent 70%);
  pointer-events: none;
}

.dot-pattern {
  position: absolute;
  width: 32px;
  height: 32px;
  background-image: radial-gradient(rgba(255, 255, 255, 0.3) 1.5px, transparent 1.5px);
  background-size: 8px 8px;
  pointer-events: none;
}
.dot-pattern.top-left { top: 20px; left: 22px; }
.dot-pattern.bottom-right { bottom: 20px; right: 22px; }

.logo-container {
  margin-bottom: 0.8rem;
  display: inline-block;
}

.blocked-logo {
  max-width: 105px;
  max-height: 55px;
  object-fit: contain;
  filter: drop-shadow(0 4px 16px rgba(255, 43, 62, 0.3));
}

.badge-error {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0.35rem 0.9rem;
  border-radius: 50px;
  background: rgba(255, 43, 62, 0.15);
  border: 1px solid rgba(255, 43, 62, 0.45);
  color: #ff8591;
  font-size: 0.78rem;
  font-weight: 700;
  margin-bottom: 0.8rem;
  box-shadow: 0 0 15px rgba(255, 43, 62, 0.2);
}

.badge-dot {
  width: 7px;
  height: 7px;
  background-color: #ff2b3e;
  border-radius: 50%;
  box-shadow: 0 0 8px #ff2b3e;
}

.security-visual-box {
  width: 100px;
  height: 100px;
  margin: 0.4rem auto 1.1rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 43, 62, 0.08);
  border: 2px dashed rgba(255, 43, 62, 0.55);
  border-radius: 22px;
  box-shadow: 0 0 25px rgba(255, 43, 62, 0.2);
  overflow: hidden;
}

.security-visual-box svg {
  width: 55px;
  height: 55px;
  stroke: #ff5264;
}

.laser-line {
  position: absolute;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, transparent, #ff2b3e, #fff, #ff2b3e, transparent);
  box-shadow: 0 0 12px #ff2b3e;
  top: 0;
  animation: scanLaser 2.2s ease-in-out infinite alternate;
}

@keyframes scanLaser {
  0% { top: 6%; }
  100% { top: 92%; }
}

.blocked-title {
  font-size: 1.25rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 0.65rem;
}

.blocked-desc {
  font-size: 0.8rem;
  color: #d1c9df;
  line-height: 1.7;
  margin-bottom: 1.3rem;
  padding: 0 0.4rem;
}

.security-note {
  background: rgba(245, 192, 68, 0.08);
  border: 1px solid rgba(245, 192, 68, 0.25);
  border-radius: 14px;
  padding: 0.65rem 0.85rem;
  margin-bottom: 1.4rem;
  font-size: 0.75rem;
  color: #f7d277;
  display: flex;
  align-items: center;
  text-align: right;
}

.blocked-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.btn-custom {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1rem;
  border-radius: 16px;
  font-size: 0.9rem;
  font-weight: 700;
  text-decoration: none;
  transition: all 0.25s ease;
  cursor: pointer;
}

.btn-gold {
  background: linear-gradient(135deg, #fce07a 0%, #e0a324 100%);
  color: #1b1204 !important;
  box-shadow: 0 6px 20px rgba(224, 163, 36, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.4);
}

.btn-gold:hover {
  background: linear-gradient(135deg, #fff09e 0%, #f1b333 100%);
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(224, 163, 36, 0.55);
}

.copyright {
  margin-top: 1.5rem;
  font-size: 0.74rem;
  color: rgba(255, 255, 255, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
</style>
